"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeBabylon = void 0;
const ValueObjects_1 = require("../ValueObjects");
const MemoizedBoolean_1 = require("./MemoizedBoolean");
const MemoizedVector2_1 = require("./MemoizedVector2");
const ObserverList_1 = require("./ObserverList");
function makeBabylon() {
    return new BabylonImp();
}
exports.makeBabylon = makeBabylon;
class BabylonImp {
    constructor() {
        this.observers = new ObserverList_1.ObserverList();
        this.updateCanvasSize = () => {
            if (!this.workingCanvas)
                return;
            if (!this._renderCanvas)
                return;
            if (this.workingCanvas.height === this._renderCanvas.height &&
                this.workingCanvas.width === this._renderCanvas.width) {
                return;
            }
            if (this.resizeEngine) {
                this.resizeEngine();
            }
            this.workingCanvas.height = this._renderCanvas.height;
            this.workingCanvas.width = this._renderCanvas.width;
            this.observers.notify();
        };
        this.submitRenderCanvas = (canvas) => {
            if (canvas === this._renderCanvas)
                return;
            if (this._renderCanvas && this.stopRendering) {
                this.stopRendering(this._renderCanvas);
            }
            this._renderCanvas = canvas;
            this.updateCanvasSize();
            if (this.startRendering) {
                this.startRendering(canvas);
            }
            this.observers.notify();
        };
        this.clearRenderCanvas = () => {
            if (!this._renderCanvas)
                return;
            if (this.stopRendering) {
                this.stopRendering(this._renderCanvas);
            }
            this._renderCanvas = undefined;
            this.observers.notify();
        };
        this.registerResizeEnging = (resizeEngine) => {
            this.resizeEngine = resizeEngine;
        };
        this.registerStartRendering = (startRendering) => {
            this.startRendering = startRendering;
        };
        this.registerStopRendering = (stopRendering) => {
            this.stopRendering = stopRendering;
        };
        this.addObserver = (observer) => {
            this.observers.add(observer);
        };
        this.removeObserver = (observer) => {
            this.observers.remove(observer);
        };
        this.makeSceneObjectMeta = (id) => {
            return { sceneObjectID: id };
        };
        this.getSceneObjectIDFromMeta = (meta) => {
            if (meta === null || meta === void 0 ? void 0 : meta.hasOwnProperty("sceneObjectID")) {
                return meta.sceneObjectID;
            }
            else {
                return;
            }
        };
        this.memoizedIsRendering = new MemoizedBoolean_1.MemoizedBoolean(false, this.observers.notify);
        this.sceneRayPick = (ray) => {
            throw new Error("Scene ray pick has not been injected");
        };
        this.sceneObjectRayPick = (ray) => {
            try {
                const pick = this.sceneRayPick(ray);
                if (pick === undefined)
                    return;
                const sceneObjectId = this.getSceneObjectIDFromMeta(pick.objectPickMeta);
                return sceneObjectId;
            }
            catch (e) {
                console.warn(e);
                return;
            }
        };
        this.sceneObjectPixelPick = (pixelPos) => {
            try {
                const ray = this.pixelToSceneRay(pixelPos);
                return this.sceneObjectRayPick(ray);
            }
            catch (e) {
                console.warn(e);
                return;
            }
        };
        this.scenePixelPick = (pixelPos) => {
            try {
                const ray = this.pixelToSceneRay(pixelPos);
                return this.sceneRayPick(ray);
            }
            catch (e) {
                console.warn(e);
                return;
            }
        };
        this.pixelToSceneRay = (pixelPos) => {
            throw new Error("Pixel to scene ray has not been injected");
        };
        this.memoizedShowInspector = new MemoizedBoolean_1.MemoizedBoolean(false, this.observers.notify);
        this.memoizedCanvasSize = new MemoizedVector2_1.MemoizedVector2(ValueObjects_1.Vector2.One(), this.observers.notify);
    }
    get showInspector() {
        return this.memoizedShowInspector.val;
    }
    set showInspector(val) {
        this.memoizedShowInspector.val = val;
    }
    get renderCanvas() {
        return this._renderCanvas;
    }
    get canvasSize() {
        return this.memoizedCanvasSize.val;
    }
    set canvasSize(val) {
        this.memoizedCanvasSize.val = val;
    }
    get isRendering() {
        return this.memoizedIsRendering.val;
    }
    set isRendering(val) {
        this.memoizedIsRendering.val = val;
    }
}
